import Dropdown from "react-bootstrap/Dropdown";
import styled from "styled-components";
import { PropsWithChildren } from "react";
import { useTranslation } from "react-i18next";
// import { isTemplateExpression } from "typescript";
// import { DropdownItemText } from "react-bootstrap";

const DropdownButton = styled(Dropdown.Toggle as any)`
  border-radius: 21px;
  border: none;
  outline: 1px var(--lime_green) solid; 
  outline-offset: -1px; 
  background-color:white;
  color: var(--dark_blue);
  font-family: Trebuchet MS; 
  font-weight: 700;
  &:hover {
    border: none;
    background: var(--dark_green) !important;
    color: white !important;
  };
  &:focus {
    border: none;
    background: var(--dark_green) !important;
    color: white !important;
  };
  &.active {
    border: none;
    background: var(--dark_green) !important;
    color: white !important;
  };
  &:show {
    border: none;
    background: var(--dark_green) !important;
    color: white !important;
  }
`;
const DropdownElement = styled(Dropdown as any)`
`;

const DropdownItem = styled(Dropdown.Item as any)`
`;

const DropdownMenu = styled(Dropdown.Menu as any)`
`;

type DesktopControlDropdownProps = {
  title: string,
  hasSelection: boolean,
  clear?: () => void,
  children: any,
};

function DesktopControlDropdown({
  title,
  hasSelection,
  clear,
  children,
}: PropsWithChildren<DesktopControlDropdownProps>) {
  const { t } = useTranslation();
  return (
    <DropdownElement 
      className="margin-right-05 margin-top-1 nice_font">
      <DropdownButton className={hasSelection ? "active nice_font" : " nice_font"}>
        {title}
      </DropdownButton>
      <DropdownMenu>
        <div className="padding-2 nice_font">{children}</div>
        {clear && (
          <DropdownItem
            as="button"
            onClick={clear}
            className="display-flex flex-justify-center body_font"
            key={title}
          >
            <div style={{'fontFamily':'Trebuchet MS'}}>{t("clear")}</div>
          </DropdownItem>
        )}
      </DropdownMenu>
    </DropdownElement>
  );
}

export default DesktopControlDropdown;
